<template>
  <div class="bg-white border-radius--light">
    <ValidationObserver ref="form">
      <div class="row pl-3 pb-3 pr-3 pt-1">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-12 col-md-6 pt-2">
                  <ValidationProvider
                    v-slot="{ errors, validate }"
                    mode="lazy"
                    rules="required"
                    :custom-messages="{ required: 'Día es requerido.' }"
                  >
                    <CustomDatePicker
                      v-model="model.day"
                      label="Día:"
                      regular-label
                      class-container="w-100"
                      :min-date="yesterday"
                      :disabled="readonly"
                      :error="errors[0]"
                      :custom-error-msg="errors[0]"
                      @input="
                        validate($event);
                        validateScheduledDates();
                      "
                    />
                  </ValidationProvider>
                </div>

                <div class="col-12 col-md-6 pt-2">
                  <ValidationProvider
                    v-slot="{ errors, validate }"
                    mode="lazy"
                    rules="required"
                    :custom-messages="{ required: 'Hora es requerido.' }"
                  >
                    <CustomTimePicker
                      v-model="model.hour"
                      label="Hora:"
                      regular-label
                      class-container="w-100"
                      :disabled="readonly"
                      :error="errors[0]"
                      :custom-error-msg="errors[0]"
                      @input="
                        validate($event);
                        validateScheduledDates();
                      "
                    />
                  </ValidationProvider>
                </div>

                <div class="col-12 pt-1">
                  <ValidationProvider v-slot="{ errors }" vid="date">
                    <Error
                      v-if="errors[0]"
                      variant="no-border"
                      :message="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4 pt-2">
              <ValidationProvider
                v-slot="{ errors, validate }"
                mode="lazy"
                rules="required"
                :custom-messages="{ required: 'Lugar es requerido.' }"
              >
                <template v-if="readonly">
                  <label class="data-label regular">Lugar:</label>
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    :value="model.place"
                  />
                </template>
                <template v-else>
                  <CustomInput
                    v-model="model.place"
                    label="Lugar:"
                    label-class="regular"
                    :disabled="readonly"
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    @input="validate"
                  />
                </template>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <slot name="actions" />

        <div class="col-12 pt-2">
          <ValidationProvider
            v-slot="{ errors, validate }"
            mode="lazy"
            rules="required"
            :custom-messages="{ required: 'Favor escriba un comentario.' }"
          >
            <CustomTextArea
              v-model="model.comment"
              label="Comentario:"
              regular-label
              :disabled="readonly"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-right']"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              @input="validate"
            />
          </ValidationProvider>
        </div>

        <div v-if="!readonly" class="col-12 pt-4">
          <div class="d-flex flex-column flex-sm-row justify-content-end">
            <div>
              <ActionButton
                text="Cancelar"
                variant="outline-danger"
                i="fas fa-times-circle"
                class="btn-block"
                @click="cancel(true)"
              />
            </div>
            <div class="my-2 mx-2 my-sm-0" />
            <div>
              <ActionButton
                :text="editting ? 'Guardar' : 'Añadir'"
                variant="success"
                :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
                class="btn-block"
                @click="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import CustomTimePicker from 'custom-time-picker';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import Error from 'custom-error';
import alert from '@/mixin/alert.mixin';

import {
  initModelState,
  modelDateToPayload,
  arrayContainsDate,
  yesterday,
} from '../_utils';

export default {
  name: 'ScheduleOREMeetingForm',
  mixins: [alert],
  components: {
    CustomDatePicker,
    CustomTimePicker,
    CustomInput,
    CustomTextArea,
    ActionButton,
    Error,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    scheduledDates: { type: Array, default: () => [] },
  },
  data: () => ({ model: initModelState() }),
  computed: {
    yesterday() {
      return yesterday;
    },
    scheduledDatesFiltered() {
      if (this.editting) {
        return this.scheduledDates.filter((x) => x.id !== this.model.id);
      }
      return this.scheduledDates;
    },
  },
  methods: {
    async submit() {
      const formValid = await this.$refs['form'].validate();
      const scheduleValid = this.validateScheduledDates();
      if ([formValid, scheduleValid].every(Boolean)) {
        this.$emit('submit', this.model, this.cancel);
      } else {
        this.ShowToast(
          'Error',
          'Favor de completar información para continuar',
          'error'
        );
      }
    },
    cancel(reInit = false) {
      if (reInit) {
        this.model = this.editting ? this.item : initModelState();
      }
      this.$emit('cancel');
      this.$refs['form'].reset();
    },
    validateScheduledDates() {
      const day = this.model.day;
      const hour = this.model.hour;
      if (!day || !hour) {
        this.$refs['form'].setErrors({
          date: [],
        });
        return true;
      }
      const date = modelDateToPayload(day, hour);
      const valid = !arrayContainsDate(
        this.scheduledDatesFiltered.map((x) => x.date),
        date
      );
      this.$refs['form'].setErrors({
        date: valid
          ? []
          : ['Ya cuenta con una reunión para la misma fecha a la misma hora.'],
      });
      return valid;
    },
    setModelFromItem() {
      if (this.item) {
        this.model = { ...this.model, ...this.item };
      }
    },
  },
  created() {
    this.setModelFromItem();
  },
  updated() {
    this.setModelFromItem();
  },
};
</script>
